// @flow
import styled from "styled-components";
import { below } from "../../assets/css/media";

export const SwitchButton = styled.button`
	display: block;
    cursor: pointer;
	height: 25px;
	width: 50px;
	background-color: #C0C0C0;
	border: none;
	color: #ffffff;
	border-radius: ${({ up }) => up ? '3px 3px 0 0' : '0 0 3px 3px'}

	&:disabled {
		opacity: .1;
	}

	svg {
		pointer-events: none;
	}

	${below.phone`
		width: 40px;
		height: 20px;
		font-size: 9px;
	`};
`;

export default SwitchButton;


// WEBPACK FOOTER //
// ./src/components/SwitchButton/index.js